<ng-container *ngIf="links">
  <ul class="flex justify-center items-center flex-wrap gap-x-20 gap-y-32">
    <li *ngFor="let link of links">
      <a
        [href]="link.url"
        target="_blank"
        class="block w-20"
        [ngClass]="isBlack ? 'text-black' : 'text-orange'"
      >
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'linkedin'">
          <app-linkedin></app-linkedin>
        </ng-container>
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'github'">
          <app-github></app-github>
        </ng-container>
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'twitter'">
          <app-twitter></app-twitter>
        </ng-container>
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'facebook'">
          <app-facebook></app-facebook>
        </ng-container>
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'website'">
          <app-website></app-website>
        </ng-container>
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'email'">
          <app-email></app-email>
        </ng-container>
        <ng-container *ngIf="link.linkType?.toLowerCase() === 'mastodon'">
          <app-mastodon></app-mastodon>
        </ng-container>
      </a>
    </li>
  </ul>
</ng-container>
